import path from 'node:path'
import { REMOVED_SCOPE } from '@cli-constants/snapshots.js'
import { snapshotRoot } from './snapshot-root.js'

export function removedDir(cwd: string): string {
  return path.join(snapshotRoot(cwd), REMOVED_SCOPE)
}
